export default {
  data () {
    return {
      layerModules: [
        "esri/core/Collection",
        "esri/layers/WMSLayer",
        "esri/layers/support/WMSSublayer"
      ],
      // 拓展图层相关变量
      operationLayerMap: {},
      operationSublayerMap: {} // 行政区划子图层映射关系
    }
  },
  methods: {
    // geo创建operationLayerMap映射关系
    createGeoserverOperationLayer () {
      this.gisConfig.map['operationalLayers'].forEach(operational => {
        this.operationLayerMap[operational.label] = this.createGeoserverLayer(operational)
      })
    },
    // geo建立图层
    createGeoserverLayer (service) {
      const sublayer = new this.gisConstructor.WMSSublayer({ name: service.identifier })
      const sublayers = new this.gisConstructor.Collection()
      sublayers.push(sublayer)
      const layer = new this.gisConstructor.WMSLayer(service.url, {
        title: service.label,
        imageFormat: "image/png",
        version: "1.1.1",
        visible: service.visible,
        id: service.label,
        sublayers
      })
      this.map.layers.add(layer)
      return layer
    },
    // 创建专题图层映射
    createOperationSublayerMap (layer) {
      console.log(layer)
      if (layer.id !== '行政区划') return
      layer.visible = true
      const sublayer = (layer.sublayers && layer.sublayers.items) || []
      sublayer.forEach(item => {
        this.operationSublayerMap[item.title] = item
      })
    }
  }
}
